import React from "react";
import { Box, Typography, Slider } from "@mui/material";

// 🔥 STATUS LOGIC
const getBatteryInfo = (value) => {
    if (value <= 20) {
        return {
            text: "Nearly empty — need urgent recharge ⚠️",
            color: "#dc2626", // red
        };
    }

    if (value <= 40) {
        return {
            text: "Running low — feeling the strain",
            color: "#f97316", // orange
        };
    }

    if (value <= 60) {
        return {
            text: "Moderate — getting through the day",
            color: "#eab308", // yellow
        };
    }

    if (value <= 80) {
        return {
            text: "Good energy — functioning well",
            color: "#22c55e", // light green
        };
    }

    return {
        text: "Fully charged — thriving ✨",
        color: "#16a34a", // dark green
    };
};

const BatteryLevel = ({ value, setValue }) => {
    const info = getBatteryInfo(value);

    return (
        <Box textAlign="center" mt={3}>

            {/* 🔋 BATTERY */}
            <Box
                sx={{
                    position: "relative",
                    width: 120,
                    height: 220,
                    margin: "0 auto",
                    borderRadius: "10px",
                    border: "5px solid #bfc3cf",
                    overflow: "visible",
                    background: "#e5e7eb",

                }}
            >
                {/* TOP CAP */}
                <Box
                    sx={{
                        position: "absolute",
                        top: -18,
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: 30,
                        height: 10,
                        borderRadius: "4px",
                        background: "#bfc3cf",
                    }}
                />

                {/* FILL */}
                <Box
                    sx={{
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                        height: `${value}%`,
                        background: getBatteryInfo(value).color,
                        transition: "0.4s ease",
                    }}
                />

                {/* % TEXT */}
                <Typography
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontSize: 40,
                        fontWeight: 700,
                        color: "#111827",
                    }}
                >
                    {value}%
                </Typography>
            </Box>

            {/* STATUS */}
            <Typography mt={2} sx={{ color: info.color }}>
                {info.text}
            </Typography>

            {/* 🎚️ SLIDER */}
            <Box mt={3} px={2}>
                <Slider
                    value={value}
                    onChange={(e, val) => setValue(val)}
                    sx={{
                        height: 6,
                        borderRadius: "999px",

                        // ❌ REMOVE DEFAULT TRACK COLOR
                        "& .MuiSlider-track": {
                            background: "transparent",
                            border: "none",
                        },

                        // ✅ APPLY FULL GRADIENT HERE
                        "& .MuiSlider-rail": {
                            opacity: 1,
                            background: "linear-gradient(90deg, #dc2626, #f97316, #eab308, #16a34a)",
                        },

                        // ✅ THUMB STYLE
                        "& .MuiSlider-thumb": {
                            width: 18,
                            height: 18,
                            backgroundColor: "#fff",
                            border: "3px solid #0ea5a4",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        },
                    }}
                />

                {/* LABELS */}
                <Box display="flex" justifyContent="space-between" >
                    <Typography fontSize={12} color="#6b7280">
                        EMPTY
                    </Typography>
                    <Typography fontSize={12} color="#6b7280">
                        HALF
                    </Typography>
                    <Typography fontSize={12} color="#6b7280">
                        FULL
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default BatteryLevel; 
